

//アーバンガーデンソファーバリエーション
const targetHandle = "sofa-101764sssss";

// ★ 一番最初に即注入（チラつき防止）
const styleTag = document.createElement('style');
styleTag.textContent = `
  product-variants[handle="${targetHandle}"] .block-swatch:nth-child(4) { 
    display: none !important; 
  }
`;
document.head.appendChild(styleTag);

// ★ 以降はダブル選択時のみ表示に切り替え
const getMainContainer = () => {
  const all = document.querySelectorAll(`product-variants[handle="${targetHandle}"]`);
  for (const el of all) {
    if (el.querySelector('input[type="radio"][name="option1"]')) return el;
  }
  return null;
};

const applySideTableLogic = () => {
  const container = getMainContainer();
  if (!container) return;
  const checked = container.querySelector('input[name="option1"]:checked');
  if (!checked) return;

  if (checked.value === 'ダブル') {
    styleTag.textContent = `
      product-variants[handle="${targetHandle}"] .block-swatch:nth-child(4) { 
        display: inline-flex !important; 
      }
    `;
  } else {
    styleTag.textContent = `
      product-variants[handle="${targetHandle}"] .block-swatch:nth-child(4) { 
        display: none !important; 
      }
    `;
    const sideTableInput = container.querySelector('input[value="サイドテーブル付"]');
    if (sideTableInput?.checked) {
      const defaultInput = container.querySelector('input[value="肘掛けあり"]');
      if (defaultInput) {
        defaultInput.checked = true;
        defaultInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
};

setInterval(applySideTableLogic, 100);

document.addEventListener('change', (e) => {
  if (e.target.name === 'option1') setTimeout(applySideTableLogic, 10);
});